"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadCampaignConnectionToSFStatusFail = exports.loadCampaignConnectionToSFStatusSuccess = exports.loadCampaignConnectionToSFStatus = exports.connectCampaignToSFFail = exports.connectCampaignToSFSuccess = exports.connectCampaignToSFById = void 0;

var _reduxAct = require("redux-act");

var PREFIX = 'SETTINGS/CAMPAIGN/CONNECTSF';
var connectCampaignToSFById = (0, _reduxAct.createAction)("".concat(PREFIX, "/SEND_CONNECT_TO_SF_REQUEST"));
exports.connectCampaignToSFById = connectCampaignToSFById;
var connectCampaignToSFSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SEND_CONNECT_TO_SF_SUCCESS"));
exports.connectCampaignToSFSuccess = connectCampaignToSFSuccess;
var connectCampaignToSFFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SEND_CONNECT_TO_SF_FAIL"));
exports.connectCampaignToSFFail = connectCampaignToSFFail;
var loadCampaignConnectionToSFStatus = (0, _reduxAct.createAction)("".concat(PREFIX, "/LOAD_STATUS_REQUEST"));
exports.loadCampaignConnectionToSFStatus = loadCampaignConnectionToSFStatus;
var loadCampaignConnectionToSFStatusSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/LOAD_STATUS_SUCCESS"));
exports.loadCampaignConnectionToSFStatusSuccess = loadCampaignConnectionToSFStatusSuccess;
var loadCampaignConnectionToSFStatusFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/LOAD_STATUS_FAIL"));
exports.loadCampaignConnectionToSFStatusFail = loadCampaignConnectionToSFStatusFail;